// extracted by mini-css-extract-plugin
export var slider_btn = "blog-module--slider_btn--Y+oQS";
export var slider_card = "blog-module--slider_card--KwfJk";
export var Readd = "blog-module--Readd--gXg67";
export var slider_cardcontent = "blog-module--slider_cardcontent--zb3uV";